module.exports = __webpack_public_path__ + "img/tutorial-step-completed-modal.2ec2108c.svg";